
export const priorityOptions = [
    { label: 'Critical', color: '#f44336' },
    { label: 'High', color: '#ff9800' },
    { label: 'Medium', color: '#2196f3' },
    { label: 'Low', color: 'gray' },
];

// Status options
export const statusOptions = [
    { label: 'Not Started', color: '#9e9e9e' },
    { label: 'In Progress', color: '#2196f3' },
    { label: 'Review Needed', color: '#ff9800' },
    { label: 'Completed', color: '#4caf50' },
];

export const getStatusFromProgress = (progress) => {
    if (progress === 0) return "Not Started";
    if (progress === 100) return "Review Needed";
    return "In Progress";
};

export const quillModules = {
    toolbar: [
        [{ font: [] }], // Font family
        [{ size: ['small', false, 'large', 'huge'] }], // Font size
        ['bold', 'italic', 'underline', 'strike'], // Text formatting
        [{ color: [] }, { background: [] }], // Text color / background
        [{ script: 'sub' }, { script: 'super' }], // Subscript / Superscript
        [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1'}, { indent: '+1' }], // Lists & indent
        [{ direction: 'rtl' }], // Text direction
        ['blockquote', 'code-block'], // Block styles
        ['clean'], // Remove formatting
    ]
};
